import React from 'react';
import i18n from '@/i18n';
import { createEnum } from '@/infrastructure/object-operator';

export const COMPARE_STATUS = createEnum({
  NEW: [1, { text: i18n.t('新增'), color: '#F04352' }],
  REMAINING: [2, { text: i18n.t('遗留'), color: '#FA974B' }],
  RESOLVED: [3, { text: i18n.t('已解决'), color: '#00C788' }],
});

export const renderCompareStatus = (status: number) => <div>
  <span
    className={'status-color'}
    style={{
      width: '7px',
      height: '7px',
      borderRadius: '50%',
      display: 'inline-block',
      background: COMPARE_STATUS.getDescFromValue(status)?.color,
      marginRight: '5px',
      marginBottom: '2px',
    }}
  >
  </span>
  <span style={{ fontSize: '14px' }}>{COMPARE_STATUS.getDescFromValue(status)?.text}</span>
</div>;
